// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { bool, func, string } from 'prop-types'

const Export = ({ buttonClasses, exportResults, hasResults, idRoot }) => (
  exportResults
    ? (
      <a
        id={`${idRoot}export`}
        className={`${buttonClasses} ${(!hasResults && `cursor-not-allowed`)} bg-grey-dark`}
        onClick={() => exportResults()}>
        {'Export'}
      </a>
    ) : null
)

Export.propTypes = {
  buttonClasses: string.isRequired,
  exportResults: func,
  hasResults: bool.isRequired,
  idRoot: string.isRequired,
}

export default Export
